import { t } from '@lingui/core/macro';
import { Box } from '@pocketlaw/tetris';
import { TextAreaField } from 'shared/domains/forms';
export function DescriptionField() {
    return (<Box flexDirection="column">
      <TextAreaField autosizeHeight maxHeight={250} name="description" label={t({ message: 'Description', comment: 'Edit project dialog - Description input label' })} placeholder={t({
            message: 'Project description...',
            comment: 'Edit project dialog - Description input placeholder',
        })}/>
    </Box>);
}
